import React, { useEffect, useState } from "react";
import axios from "axios";
import { BaseUrl, BaseUrlInvoice } from "../formcomponents/Constants";
import { Tab, Header } from "semantic-ui-react";
import PurchaseList from "./PurchaseList";
import { useParams } from "react-router-dom";
const PurchaseListWithCat = () => {
  const [rowData, setrowData] = useState([]);
  const { catId } = useParams();
  const [activeTabIndex, setActiveTabIndex] = useState(0);
  const color = "blue";
  useEffect(() => {
    getpurchaseCatList();
  }, [catId]);

  const getpurchaseCatList = () => {
    axios
      .post(BaseUrlInvoice + "/accounts/listPurchaseCategory", {
        categoryId: "",
      })
      .then((res) => {
        console.log("res", res.data);

        const tempArr = [...rowData];
        // setrowData(res.data);

        for (let i = 0; i < res.data.length; i++) {
          tempArr.push({
            categoryId: res.data[i].categoryId,
            categoryName: res.data[i].categoryName,
          });
        }
        tempArr.push({
          categoryId: 0,
          categoryName: "All",
        });
        setrowData(tempArr);
        if (catId != "null") {
          const indexToSetActive = tempArr.findIndex(
            (item) => item.categoryId === Number(catId)
          );
          setActiveTabIndex(indexToSetActive);
        }
      })
      .catch((error) => console.log(error));
  };
  const handleTabChange = (e, { activeIndex }) => {
    console.log("cat id", activeIndex);
    setActiveTabIndex(activeIndex); // Update the active tab index when a tab is clicked
  };

  const panes = rowData.map((item, index) => ({
    menuItem: `${item.categoryName}`,
    render: () => (
      <Tab.Pane attached={false} key={index}>
        <PurchaseList categoryId={item.categoryId} />
        {/* <NewCompanyForm
          companyDetailList={companyDetailList[index]}
          indexVal={index}
        /> */}
      </Tab.Pane>
    ),
  }));
  return (
    <div>
      <Header dividing size="huge" as="h1">
        Purchase List
      </Header>
      <Tab
        menu={{ color, attached: false, tabular: false, className: "wrapped" }}
        panes={panes}
        activeIndex={activeTabIndex} // Set the active tab index
        onTabChange={handleTabChange} // Handle tab change events
      />
    </div>
  );
};

export default PurchaseListWithCat;
